import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import SectionWrapper from './SectionWrapper';
import Footer from './Footer';
import './SubscriptionActivate.scss';

class SubscriptionActivate extends React.PureComponent {
  render() {
    return (
      <div className="SubscriptionActivate">
        <div className="SubscriptionActivate__ContentWrap">
          <div className="SubscriptionActivate__ContentWrap__Content">
            <span className="SubscriptionActivate__ContentWrap__Content__Heading">
              <FormattedMessage id="views.subscriptionActivate.contentWrap.content.heading" />
            </span>
            <div className="SubscriptionActivate__ContentWrap__Content__Description__Center">
              <div>
                <FormattedMessage
                  id="views.subscriptionActivate.contentWrap.content.description.text"
                  values={{ br: <br /> }}
                />
              </div>
            </div>
            <div className="SubscriptionActivate__ContentWrap__Content__Description__Left">
              <div>
                <FormattedMessage
                  id="views.subscriptionActivate.contentWrap.content.description.list"
                  values={{ br: <br /> }}
                />
              </div>
            </div>
          </div>
          <SectionWrapper {...this.props} />
          <Footer />
        </div>
      </div>
    );
  }
}

SubscriptionActivate.propTypes = {
  windowDimension: PropTypes.object.isRequired
};

function mapStateToProps({ windowDimension }) {
  return {
    windowDimension,
  };
}

export default connect(mapStateToProps)(SubscriptionActivate);



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/SubscriptionActivate.jsx